import { ShieldAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/auth/store';
import type { Role } from '../lib/types';
import { Empty } from './ui/empty';

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

export function RequireRole({
  requiredRole,
  children,
}: {
  requiredRole: Role;
  children: ReactNode;
}): JSX.Element {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/sign-in" replace />;
  if (user.role !== requiredRole) {
    return (
      <div className="px-6 py-12">
        <Empty
          icon={ShieldAlert}
          title="Admins only"
          description={`This area requires the "${requiredRole}" role. You're signed in as "${user.role}". Ask another admin to grant you access.`}
        />
      </div>
    );
  }
  return <>{children}</>;
}
